import { Component } from 'vue-property-decorator';
import AbstractDisplayField from '../abstract-display-field/abstract-display-field';
import { mixins } from 'vue-class-component';
import moment from 'moment';

@Component({
  name: 'bpc-display-field-booking-event-conflict',
  components: {},
})
export default class DisplayFieldBookingEventConflicts extends mixins(AbstractDisplayField) {
  public id = Math.floor(Math.random() * 10000);

  get icon(): string {
    return 'exclamation-triangle';
  }

  get valueLabel(): string {
    const item = this.fieldConfig.valueToLabel?.find(item => item.value === this.value);
    return item?.label || item.text || this.value;
  }

  get tooltipBookingEventReference() {
    let referenceLine = '';
    this.value.forEach(bookingEvent => {
      referenceLine +=
        '[' +
        bookingEvent.code +
        ']' +
        ' ' +
        this.formatDate(bookingEvent.date) +
        ' ' +
        this.formatTime(bookingEvent.start_time) +
        '-' +
        this.formatTime(bookingEvent.end_time) +
        '<br>';
    });
    return referenceLine;
  }

  get tooltipBookingEventContact() {
    let contactLine = '';
    this.value.forEach(bookingEvent => {
      contactLine += bookingEvent.contact?.fullname + '<br>';
    });
    return contactLine;
  }

  get tooltipBookingEventResource() {
    let resourceLine = '';
    this.value.forEach(bookingEvent => {
      resourceLine += bookingEvent.resource?.name + '<br>';
    });
    return resourceLine;
  }

  get popoverConfig() {
    return {
      html: true,
      title: () => {
        return this.$t('global.events_in_conflict');
      },
      content: () => {
        return (
          this.tooltipBookingEventReference +
          this.tooltipBookingEventContact +
          this.tooltipBookingEventResource
        );
      },
    };
  }

  formatDate(date): string {
    if (date) {
      return moment(String(date)).format('DD/MM/YYYY');
    }
    return '';
  }

  formatTime(time): string {
    if (time) {
      return time.substr(0, 5);
    }
    return '';
  }
}
